import React, { useContext, useEffect, useMemo } from "react";
import { Box, CircularProgress } from "@mui/material";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useHistory } from "react-router-dom";
import { useEffectOnce } from "react-use";
import { actions } from "rdx";
import { useAppDispatch } from "hooks/redux";
import { SettingsContext } from "context/SettingsContext";
import SessionClient from "util/SessionClient";
import HeaderLogoLarge from "components/Icons/Logos/HeaderLogoLarge";
import PaymentRequiredForm from "./PaymentRequiredForm";
import * as S from "./styles";

const PaymentRequired = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const settings = useContext(SettingsContext);
  const stripeKey: string | undefined = settings?.stripe_api_key;
  const stripePromise = useMemo(() => (stripeKey ? loadStripe(stripeKey) : null), [stripeKey]);

  useEffect(() => {
    return () => {
      dispatch(actions.clearAlertMessage());
    };
  }, [dispatch]);

  useEffectOnce(() => {
    const session = new SessionClient();

    if (!session.jwt) {
      history.replace("/login");
      return;
    }

    const userProps = session.user?.props;

    if (userProps?.emailVerified === false) {
      history.replace("/verify-email-required");
      return;
    }

    if (!(userProps?.enrollment?.paymentRequired === true && userProps?.requirePaymentData !== true)) {
      history.replace("/dashboard");
    }
  });

  return (
    <Box sx={S.pageWrapper}>
      <Box sx={S.backgroundGradient} />
      <Box sx={S.logoWrapper}>
        <HeaderLogoLarge width="146px" height="46px" />
      </Box>
      {stripeKey ? (
        <Elements stripe={stripePromise}>
          <PaymentRequiredForm />
        </Elements>
      ) : (
        <CircularProgress sx={S.spinner} />
      )}
    </Box>
  );
};

export default PaymentRequired;
